<template>
  <div>
    <div class="page-title">
      添加新闻资讯
    </div>
    <div class="baseInfo-area">
      <el-form :model="baseInfo" ref="form" :rules="rules" :inline="false" size="small">
        <el-form-item label="标题" prop="title">
          <el-input v-model.trim="baseInfo.title" placeholder="请输入标题" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="概要" prop="des">
          <el-input v-model.trim="baseInfo.des" type="textarea" placeholder="请输入概要" maxlength="200" show-word-limit :autosize="{ minRows: 3}"></el-input>
        </el-form-item>
        <el-form-item label="图片地址" prop="image">
          <el-input v-model.trim="baseInfo.image" placeholder="请输入图片网络地址" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-area">
      <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
    </div>
    <div class="footer-area">
      <el-button type="primary" size="default" @click="updateArticle('form')">立即发布</el-button>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  data () {
    return {
      baseInfo: {
        title: '',
        des: '',
        image: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        des: [
          { required: true, message: '请输入概要', trigger: 'blur' },
          { min: 10, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '图片地址不能为空', trigger: 'blur' }
        ]
      },
      editor: ClassicEditor,
      editorData: '<p>开始填写内容...</p>',
      editorConfig: {
        // The configuration of the editor.
      }
    }
  },
  methods: {
    updateArticle (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const postData = that.baseInfo
          postData.content = that.editorData
          that.axios.post('admin/blog', postData).then(function (resp) {
            console.log(resp.data)
            if (resp.data.code === 0) {
              that.$alert('发布成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  that.init()
                }
              })
            }
            if (resp.data.code === 1) {
              that.$alert(resp.data.msg, '提示', {
                confirmButtonText: '确定'
              })
            }
          })
        } else {
          that.$message.error('还有必填项未填写')
        }
      })
    },
    init () {
      this.baseInfo = {
        title: '',
        des: '',
        image: ''
      }
      this.editorData = '<p>开始填写内容...</p>'
    }
  }
}
</script>

<style scoped>
.baseInfo-area,.edit-area,.footer-area{
  max-width: 1200px;
  margin: 50px auto;
}
.footer-area{
  text-align: right;
}
.page-title{
  max-width: 1200px;
  margin: 50px auto 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #DCDFE6;
}
</style>
